module.exports = __webpack_public_path__ + "static/media/Nutzungsbedingungen.461bb30a.docx";


//////////////////
// WEBPACK FOOTER
// ./src/assets/docs/Nutzungsbedingungen.docx
// module id = 1515
// module chunks = 0